module.exports = __webpack_public_path__ + "static/domain-whois_5-052bf88d6dcba36242e688d409cd12e3.jpg";